// extracted by mini-css-extract-plugin
module.exports = {"errorHeader":"style__errorHeader__50vCg","errorMsg":"style__errorMsg__2DMnD"};